module.exports = __webpack_public_path__ + "media/Video07.de99dd86.mp4";